import type { PartnershipRecord } from "Order/Modules/MorningCheck/Api/Query/usePartnershipRecordsQuery";
import {
	Card,
	CardContent,
	CardHeader,
	Stack,
	Typography,
} from "@mui/material";
import type { FC } from "react";

type MorningCheckNoteForAdamCardProps = {
	records: PartnershipRecord[];
};

export const MorningCheckNoteForAdamCard: FC<
	MorningCheckNoteForAdamCardProps
> = ({ records }) => {
	const notes = records.filter(
		(record) => record.note_for_adam && record.note_for_adam.trim() !== "",
	);

	if (notes.length === 0) {
		return null;
	}

	return (
		<Card variant="outlined">
			<CardHeader
				title="Note for Adam"
				subheader={
					<Typography variant="body2" color="text.secondary">
						Sent by the partner from partner's portal.
					</Typography>
				}
				titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
				sx={{ pb: 0 }}
			/>
			<CardContent sx={{ pt: 1 }}>
				<Stack gap={1}>
					{notes.map((record) => (
						<Card
							key={record.id}
							variant="outlined"
							sx={{ bgcolor: "background.default" }}
						>
							<CardContent sx={{ py: 1, px: 1.5, "&:last-child": { pb: 1 } }}>
								<Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
									{record.note_for_adam}
								</Typography>
							</CardContent>
						</Card>
					))}
				</Stack>
			</CardContent>
		</Card>
	);
};
